import http from "../jslibs/axios/http";

// 标签列表
export const getArticleTag = (data) => http.get("/v1/cms/ArticleTag", data);

// 新增标签
export const addArticleTag = (data) => http.post("/v1/cms/ArticleTag", data);

// 删除标签
export const deleteArticleTag = (id) => http.delete(`/v1/cms/ArticleTag/${id}`);

// 编辑标签
export const editArticleTag = (id, data) => http.put(`/v1/cms/ArticleTag/${id}`, data);

// 标签详情
export const articleTagDetail = (id) => http.get(`/v1/cms/ArticleTag/${id}`);

// 分类列表
export const getArticleClass = (data) => http.get("/v1/cms/ArticleClass", data);

// 新增分类
export const addArticleClass = (data) => http.post("/v1/cms/ArticleClass", data);

// 删除分类
export const deleteArticleClass = (id) => http.delete(`/v1/cms/ArticleClass/${id}`);

// 编辑分类
export const editArticleClass = (id, data) => http.put(`/v1/cms/ArticleClass/${id}`, data);

// 分类详情
export const articleClassDetail = (id) => http.get(`/v1/cms/ArticleClass/${id}`);

// 文章列表
export const getArticle = (data) => http.get("/v1/cms/Article", data);

// 新增文章
export const addArticle = (data) => http.post("/v1/cms/Article", data);

// 删除文章
export const deletArticle = (id) => http.delete(`/v1/cms/Article/${id}`);

// 编辑文章
export const editArticle = (id, data) => http.put(`/v1/cms/Article/${id}`, data);

// 文章详情
export const articleDetail = (id) => http.get(`/v1/cms/Article/${id}`);

// 推荐/取消推荐文章
export const articleRecommend = (id, type) => http.get(`/v1/cms/ArticleRecommend/${id}?recommend_type=${type}`);

// 隐藏/显示文章
export const articleShow = (id) => http.get(`/v1/cms/ArticleShow/${id}`);

// 首页推荐列表
export const getArticleRecommendRecord = (data) => http.get("/v1/cms/ArticleRecommendRecord", data);

// 新增首页推荐
export const addArticleRecommendRecord = (data) => http.post("/v1/cms/ArticleRecommendRecord", data);

// 删除首页推荐
export const deletArticleRecommendRecord = (id) => http.delete(`/v1/cms/ArticleRecommendRecord/${id}`);
